import MedicalReduction from "./MedicalReduction";

export default MedicalReduction;